import { AxiosResponse } from 'axios';
import { appContextGet, appContextPost, appContextPut } from './httpCommon/appAxios.service';
import { STRIPE_CONNECT_ENDPOINTS } from '../constants/apiEndpoints';
import { StripeDocumentType } from '../types/enums';
import { StripeAccountStatus, StripeEmbeddedPayoutRequest, StripeKycDetails } from '../types/interfaces/stripeConnect.interfaces';

const accountPath = (accountId: number) => `${STRIPE_CONNECT_ENDPOINTS.ACCOUNTS_}${accountId}`;

const toKycPayload = ({ accountId: _accountId, ...kyc }: StripeEmbeddedPayoutRequest) => kyc;

export const createStripeAccount = (accountId: number): Promise<AxiosResponse<StripeAccountStatus>> => {
  return appContextPost(STRIPE_CONNECT_ENDPOINTS.ACCOUNTS, { accountId });
};

export const doesStripeAccountExist = (accountId: number): Promise<AxiosResponse<boolean>> => {
  return appContextGet(`${accountPath(accountId)}${STRIPE_CONNECT_ENDPOINTS.EXISTS}`);
};

export const getStripeAccountStatus = (accountId: number): Promise<AxiosResponse<StripeAccountStatus>> => {
  return appContextGet(`${accountPath(accountId)}${STRIPE_CONNECT_ENDPOINTS.STATUS}`);
};

export const getStripeKycDetails = (accountId: number): Promise<AxiosResponse<StripeKycDetails>> => {
  return appContextGet(`${accountPath(accountId)}${STRIPE_CONNECT_ENDPOINTS.KYC}`);
};

export const submitStripeKyc = (request: StripeEmbeddedPayoutRequest): Promise<AxiosResponse<StripeAccountStatus>> => {
  return appContextPost(`${accountPath(request.accountId)}${STRIPE_CONNECT_ENDPOINTS.KYC}`, toKycPayload(request));
};

export const updateStripeAccount = (
  accountId: number,
  request: StripeEmbeddedPayoutRequest,
): Promise<AxiosResponse<StripeAccountStatus>> => {
  return appContextPut(`${accountPath(accountId)}${STRIPE_CONNECT_ENDPOINTS.KYC}`, toKycPayload(request));
};

export const uploadStripeKycDocuments = (
  accountId: number,
  file: File,
  documentType: StripeDocumentType,
  backFile?: File,
): Promise<AxiosResponse<StripeAccountStatus>> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('documentType', documentType);
  if (backFile) formData.append('backFile', backFile);
  return appContextPost(`${accountPath(accountId)}${STRIPE_CONNECT_ENDPOINTS.DOCUMENTS}`, formData);
};
